import request from '@/utils/requests.js'

export const userService = {
  // Listar usuários com filtros
  async getUsers(params = {}) {
    return request({
      url: '/users/',
      method: 'get',
      params
    })
  },

  // Buscar usuário por ID
  async getUserById(userId) {
    return request({
      url: `/users/${userId}`,
      method: 'get'
    })
  },

  // Criar novo usuário
  async createUser(userData) {
    return request({
      url: '/users/',
      method: 'post',
      data: userData
    })
  },

  // Atualizar usuário
  async updateUser(userId, userData) {
    return request({
      url: `/users/${userId}`,
      method: 'put',
      data: userData
    })
  },

  // Deletar usuário
  async deleteUser(userId) {
    return request({
      url: `/users/${userId}`,
      method: 'delete'
    })
  },

  // Ativar usuário
  async activateUser(userId) {
    return request({
      url: `/users/${userId}/activate`,
      method: 'patch'
    })
  },

  // Desativar usuário
  async deactivateUser(userId) {
    return request({
      url: `/users/${userId}/deactivate`,
      method: 'patch'
    })
  },

  // Resetar senha
  async resetPassword(userId) {
    return request({
      url: `/users/${userId}/reset-password`,
      method: 'patch'
    })
  },

  // Estatísticas de usuários
  async getUserStats() {
    return request({
      url: '/users/stats/summary',
      method: 'get'
    })
  }
};
